import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Filter, FilterElement } from '@idto';
import { FilterService } from '@service/filter/filter.service';
import { StringVariable } from 'app/model/StringVariable.model'
import { UrlTranslateService } from '@service/helpers/url-translate.service';
import { AnalyticsService } from '@service/analytics/abstract/analytics.service';

@Component({
  selector: 'app-select-filter',
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.scss'],
  standalone: false
})
export class SelectFilterComponent
{
  get filter(): Filter
  {
    return this._filter;
  }

  get filteredElements(): FilterElement[]
  {
    return this._filteredElements;
  }


  @Input() set filter(filter: Filter)
  {
    if (filter)
    {
      this._filter = filter;
      this._filteredElements = filter.values.filter(filter => this.hasFilterTextInFilterName(filter));
      this.filterClass = this.getClass(this._filter.code);
      this.canDisplayLinkToMore2 = this.canDisplayLinkToMore(this._filter);
      this.isFilterShowAll2 = this.filterService.isFilterShowAll(this._filter);
    }
  }
  private _filter: Filter;
  private _filteredElements: FilterElement[];
  private readonly MAX_PRODUCT_FOR_NOT_HIDING = 6;
  @Output() private readonly valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() private readonly changeHeight: EventEmitter<any> = new EventEmitter<any>();
  @Output() private readonly showTooltipPopup: EventEmitter<any> = new EventEmitter<any>();
  public showPopup: boolean = false;
  @ViewChild('filterInput') public filterInput: ElementRef;
  public filterText: string = '';
  private showPopupTimeout: ReturnType<typeof setInterval>;
  private showPopupTimeoutCounting: boolean;
  public filterClass: string;
  public canDisplayLinkToMore2: boolean;
  public isFilterShowAll2: boolean;

  constructor(
    private filterService: FilterService,
    private sanitizer: DomSanitizer,
    private renderer2: Renderer2,
    private changeDet: ChangeDetectorRef,
    public urlTranslateService: UrlTranslateService,
    private analyticsService: AnalyticsService
  )
  {
  }

  public canBeShown(i, filter: Filter): boolean
  {
    return filter.code == 'kolor' || (i < this.MAX_PRODUCT_FOR_NOT_HIDING) || this.filterService.isFilterShowAll(filter);
  }

  public trackByIndex(index, item): number
  {
    return item?.code ?? index;
  }

  public toggleShowAllOptions(filter: Filter): void
  {
    this.filterService.addShowAllOptionFilter(filter, !this.filterService.isFilterShowAll(filter));
    this.isFilterShowAll2 = this.filterService.isFilterShowAll(filter);
    this.changeHeight.emit();
    this.changeDet.detectChanges();
  }

  public toggleSelected(filterOption: FilterElement, filter: Filter, $event): void
  {
    if (filterOption.recordCount > 0)
    {
      if (filter.values.filter(v => v.selected).length > 1 && filter.type == 'Select')
      {
        filter.values.filter(v => v !== filterOption).forEach((v: FilterElement) => v.selected = false);
        filterOption.selected = true;
      }
      else
      {
        filterOption.selected = !filterOption.selected;
      }

      if (filterOption.selected)
      {
        this.analyticsService.registerEvent('select_filter_attribute_value', { filter_attribute_value: filterOption.code, filter_attribute_name: filter.code }, false);
      }

      if (filter.type !== 'Multiselect')
      {
        filter.values.filter(v => v !== filterOption).forEach((v: FilterElement) => v.selected = false);
      }

      this.valueChanged.emit(this.filter);
      this.changeDet.detectChanges();
    }
    else
    {
      if ($event && $event.target.className == 'main-title')
      {
        this.changeDet.detectChanges();
      } else
      {
        filter.values.forEach(el => el['showPopup'] = false);
        this.showPopupFunc(filterOption);
      }
    }
  }

  public getFilterUrl(filter: Filter, filterOption): SafeUrl
  {

    // TODO to jest duplikacja, a na dodatek nie bierze pod uwagi intervali i multiselectow
    let query = filter.linkTemplate.replace('{CODE}', filterOption.code);
    return this.sanitizer.bypassSecurityTrustUrl(`${this.urlTranslateService.routingTable.shop.listing}?` + query);
  }

  public canDisplayLinkToMore(filter: Filter): boolean
  {
    let canBeDisplay = true;

    if ((filter.type == 'Select' || filter.type == 'Multiselect') && filter.values.length > this.MAX_PRODUCT_FOR_NOT_HIDING)
    {
      for (let i = 0; i <= this.MAX_PRODUCT_FOR_NOT_HIDING; i++)
      {
        if (filter.values[i].recordCount === 0)
        {
          canBeDisplay = false;
        }
      }
    }
    else
    {
      canBeDisplay = false;
    }

    return (filter.code != 'kolor' && canBeDisplay) || filter.code === StringVariable.CATEGORY_CODE;
  }

  public showPopupFunc(filterOption: FilterElement, b?: boolean): void
  {
    if (filterOption.recordCount === 0)
    {
      filterOption['showPopup'] = b != undefined ? b : !filterOption['showPopup'];
      if (filterOption['showPopup'])
      {
        this.showTooltipPopup.emit(true);
      }
      this.changeDet.detectChanges();
    }
  }

  private hasFilterTextInFilterName(filterOption: FilterElement): boolean
  {
    if (filterOption)
    {
      return filterOption.value.toLowerCase().indexOf(this.filterText.toLowerCase()) != -1;
    }
    return true;
  }

  public updateFilterText($event, value: string): void
  {
    this.filterText = value;
    this._filteredElements = this.filter.values.filter((element) => this.hasFilterTextInFilterName(element));
    this.changeDet.detectChanges();
  }

  public loseFocus($event: any, filterInput): void
  {
    if (filterInput && filterInput.value == '')
    {
      this.renderer2.removeClass(filterInput, 'label-up');
      filterInput.blur();
    }
    this.changeDet.detectChanges();
  }

  public delayedOpenTooltip(filterOption: FilterElement): void
  {
    if (this.showPopupTimeoutCounting == true)
    {
      return;
    }
    this.showPopupTimeoutCounting = true;
    this.showPopupTimeout = setTimeout(() =>
    {
      this.showPopupFunc(filterOption);
    }, 300);
  }

  public stopTimerTooltip(filterOption: FilterElement): void
  {
    clearTimeout(this.showPopupTimeout);
    this.showPopupTimeoutCounting = false;
    this.showPopupFunc(filterOption, false);
  }

  public boldSearchPhrase(value: string): string
  {
    const re = new RegExp(this.filterText.toLowerCase(), 'g');
    let changedValue = value.toLowerCase().replace(re, '<b>' + this.filterText + '</b>').concat(' ');
    if (changedValue.charAt(0) == '<')
    {
      changedValue = '<b>'.concat(changedValue.slice(3).charAt(0).toUpperCase().concat(changedValue.slice(4)));
    } else
    {
      changedValue = changedValue.charAt(0).toUpperCase().concat(changedValue.slice(1));
    }
    return changedValue;
  }

  public getClass(code: string): string
  {
    if (code === 'kolor')
    {
      return 'color';
    }
    if (code === 'desen')
    {
      return 'design';
    }
    if (code === 'przeznaczenie')
    {
      return 'destiny';
    }
  }

  public focusFilterInput()
  {
    setTimeout(() => this.filterInput.nativeElement.focus());
  }
}
